import APIService from "./APIService";
import { getInstance } from "../auth/auth";

const http = APIService.http;

export default {
  async getCompanyFeatures() {
    let auth = getInstance();
    let authHeaders = await auth.apiAuthConfig();
    let res = await http.get(
      `api/CategoryKeyFeatures/${auth.activeCompany.companyId}`,
      authHeaders
    );
    return res.data;
  },

  async saveSelection(categoryId, featureId, value) {
    let auth = getInstance();
    let authHeaders = await auth.apiAuthConfig();
    await http.post(
      `api/CategoryKeyFeatures/${auth.activeCompany.companyId}/selection`,
      { categoryId, featureId, value },
      authHeaders
    );
  },
};
